import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  periodContainer: {
    display: "flex",
    gap: "4px",
    justifyContent: "space-between",
    marginBottom: "8px",
    height: "26px",
  },
  periodButton: {
    width: "20%",
    height: "26px",
    borderRadius: "5px",
    padding: "5px 10px",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.palette.mainButton.contrastText,
    boxShadow: "0px 4px 15px 0px rgba(166, 166, 166, 0.10)",
    "&:hover, &.active": {
      background: theme.palette.mainButton.darkBlue,
      color: theme.palette.mainButton.contrastText,
    },
  },
}));

export default useStyles;
